(() => {
  if (window.awAtelierReady) return;
  window.awAtelierReady = true;
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  let motionOff = reduced.matches || Boolean(navigator.connection?.saveData);
  let frame = 0;
  const init = (root = document) => {
    root.querySelectorAll('[data-aw-compare]').forEach(box => {
      if (box.dataset.ready) return;
      box.dataset.ready = '1';
      const range = box.querySelector('input');
      const update = () => box.style.setProperty('--aw-compare', `${range.value}%`);
      range.addEventListener('input', update); update();
    });
    root.querySelectorAll('[data-aw-campaign-video]').forEach(video => {
      if (video.dataset.ready) return;
      video.dataset.ready = '1';
      video.muted = true;
      video.addEventListener('playing', () => video.classList.add('aw-film-ready'));
      video.addEventListener('error', () => video.classList.remove('aw-film-ready'));
      const observer = new IntersectionObserver(([entry]) => {
        video.dataset.visible = entry.isIntersecting ? '1' : '0';
        syncVideo(video);
      }, { threshold: 0.1 }); observer.observe(video);
    });
    root.querySelectorAll('[data-aw-words]').forEach(el => {
      if (el.dataset.ready) return;
      el.dataset.ready = '1';
      const words = el.textContent.trim().split(/\s+/);
      el.setAttribute('aria-label', words.join(' ')); el.textContent = '';
      words.forEach(word => {const span=document.createElement('span');span.className='aw-word';span.setAttribute('aria-hidden','true');span.textContent=word;el.append(span,document.createTextNode(' '));});
    });
    root.querySelectorAll('[data-aw-carousel]').forEach(track => {
      if (track.dataset.ready) return;
      track.dataset.ready='1';
      const section=track.closest('.aw-series-section');
      const refresh=()=>{const cards=[...track.children];if(!cards.length)return;const offset=track.scrollLeft;const last=Math.max(0,track.scrollWidth-track.clientWidth);const width=cards[0].getBoundingClientRect().width+parseFloat(getComputedStyle(track).gap||'0');const index=offset>=last-3?cards.length:Math.min(cards.length,Math.round(offset/width)+1);section.querySelector('[data-aw-slide-count]').textContent=String(index).padStart(2,'0')+' / '+String(cards.length).padStart(2,'0');section.querySelector('[data-aw-slide="-1"]').disabled=offset<3;section.querySelector('[data-aw-slide="1"]').disabled=offset>=last-3;};
      section.querySelectorAll('[data-aw-slide]').forEach(button=>button.addEventListener('click',()=>{const first=track.children[0];if(!first)return;track.scrollBy({left:(first.getBoundingClientRect().width+parseFloat(getComputedStyle(track).gap||'0'))*Number(button.dataset.awSlide),behavior:motionOff?'instant':'smooth'});}));
      track.addEventListener('scroll',refresh,{passive:true});new ResizeObserver(refresh).observe(track);refresh();
    });
    applyMotion(); renderSaved(); updateScroll();
  };
  function syncVideo(video) {
    if (motionOff || document.hidden || video.dataset.visible !== '1') {video.pause();return;}
    if (!video.getAttribute('src') && video.dataset.src) {video.src=video.dataset.src;video.load();}
    if (video.getAttribute('src') && !video.dataset.awReplayHold) video.play().catch(()=>{});
  }
  function applyMotion(){document.documentElement.classList.toggle('aw-motion-off',motionOff);document.querySelectorAll('[data-aw-motion]').forEach(button=>{button.setAttribute('aria-pressed',String(motionOff));button.textContent=motionOff?button.dataset.play:button.dataset.pause;});document.querySelectorAll('[data-aw-campaign-video]').forEach(syncVideo);document.dispatchEvent(new CustomEvent('aw:motion-change',{detail:{paused:motionOff}}));}
  function updateScroll(){frame=0;document.querySelectorAll('[data-aw-words]').forEach(el=>{const box=el.getBoundingClientRect();const progress=Math.max(0,Math.min(1,(innerHeight*.9-box.top)/(innerHeight*.65)));el.classList.toggle('aw-words-active',!motionOff);const words=[...el.querySelectorAll('.aw-word')];words.forEach((w,i)=>w.classList.toggle('aw-word-lit',motionOff||i<Math.ceil(progress*words.length)));});}
  const savedKey='artsweave-keepsakes-v1';
  function savedUrl(input) {
    if (typeof input !== 'string' || input.length > 1000) return null;
    try {
      const url = new URL(input, location.origin);
      if (url.origin !== location.origin) return null;
      const product = /^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?products\/[a-z0-9-]+\/?$/i.test(url.pathname);
      const preview = /^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?collections\/all\/?$/i.test(url.pathname) && /^#piece-[a-z0-9-]+$/i.test(url.hash);
      return product || preview ? url.pathname + url.search + url.hash : null;
    } catch { return null; }
  }
  function readSaved() {
    try {
      const data = JSON.parse(localStorage.getItem(savedKey) || '[]');
      if (!Array.isArray(data)) return [];
      const seen = new Set();
      return data.filter(p => p && typeof p.title === 'string' && p.title.length <= 250 && savedUrl(p.url) && safeImage(p.image))
        .map(p => ({ title:p.title, url:savedUrl(p.url), image:p.image }))
        .filter(p => { if (seen.has(p.url)) return false; seen.add(p.url); return true; }).slice(-30);
    } catch { return []; }
  }
  function safeImage(input) {
    if (typeof input !== 'string' || !input) return false;
    try { const u=new URL(input,location.origin);return /^https?:$/.test(u.protocol) && (u.origin===location.origin||u.hostname==='cdn.shopify.com'); } catch { return false; }
  }
  function renderSaved() {
    const saved=readSaved(); const editor=Boolean(window.Shopify?.designMode);
    document.querySelectorAll('[data-aw-save]').forEach(button => {
      const url=savedUrl(button.closest('[data-aw-piece]')?.dataset.url);
      const active=saved.some(piece=>piece.url===url);
      button.setAttribute('aria-pressed',String(active));button.textContent=active?'♥':'♡';
    });
    document.querySelectorAll('[data-aw-saved-section]').forEach(section => {
      section.hidden=!saved.length&&!editor;
      const list=section.querySelector('[data-aw-saved-list]');if(!list)return;
      list.replaceChildren();
      for(const piece of saved) {
        const link=document.createElement('a');link.href=piece.url;
        const img=document.createElement('img');img.src=piece.image;img.alt='';img.loading='lazy';img.width=500;img.height=500;
        const title=document.createElement('span');title.dataset.awItemHeading='';title.textContent=piece.title;
        link.append(img,title);list.append(link);
      }
    });
  }
  let toastTimeout;
  function announceSave(kind) { const status=document.querySelector('[data-aw-save-status]');if(!status)return;status.textContent=status.dataset[kind]||'';clearTimeout(toastTimeout);toastTimeout=setTimeout(()=>status.textContent='',kind==='error'?6000:3000); }
  document.addEventListener('click',event=>{
    const motion=event.target.closest('[data-aw-motion]');if(motion){motionOff=!motionOff;applyMotion();updateScroll();}
    const detail=event.target.closest('[data-aw-detail]');if(detail){const stage=detail.closest('.aw-detail-stage');stage.querySelector('[data-aw-detail-view]').dataset.view=detail.dataset.awDetail;stage.querySelectorAll('[data-aw-detail]').forEach(b=>b.setAttribute('aria-pressed',String(b===detail)));const caption=stage.querySelector('[data-aw-detail-caption]');caption.textContent=caption.dataset[detail.dataset.awDetail];}
    const save=event.target.closest('[data-aw-save]');
    if(save) {
      const piece=save.closest('[data-aw-piece]');const url=savedUrl(piece?.dataset.url);
      if(!url || !safeImage(piece?.dataset.image)) { announceSave('error');return; }
      const list=readSaved();const exists=list.some(p=>p.url===url);
      const updated=exists?list.filter(p=>p.url!==url):[...list,{title:piece.dataset.title,url,image:piece.dataset.image}];
      try {
        localStorage.setItem(savedKey,JSON.stringify(updated.slice(-30)));
        renderSaved();announceSave(exists?'removed':'saved');
      } catch { announceSave('error'); }
    }
    if(event.target.closest('[data-aw-clear-saved]')){try{localStorage.removeItem(savedKey);}catch{}renderSaved();}
  });
  addEventListener('scroll',()=>{if(!frame)frame=requestAnimationFrame(updateScroll);},{passive:true});
  addEventListener('storage',renderSaved);
  let cartCountRequest = 0;
  let cartCountSubscribed = false;
  async function syncCartCount(event = {}) {
    if (!document.querySelector('[data-aw-cart-count]')) return;
    const request = ++cartCountRequest;
    try {
      let cart = event.cartData || event.detail;
      if (!Number.isInteger(cart?.item_count) || cart.item_count < 0) {
        const response = await fetch((window.Shopify?.routes?.root || '/') + 'cart.js', { credentials:'same-origin', cache:'no-store' });
        if (!response.ok) return;
        cart = await response.json();
      }
      if (request !== cartCountRequest || !Number.isInteger(cart?.item_count) || cart.item_count < 0) return;
      document.querySelectorAll('[data-aw-cart-count]').forEach(count => { count.textContent = '(' + cart.item_count + ')'; });
    } catch {}
  }
  function subscribeCartCount() {
    if (cartCountSubscribed || typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
    subscribe(PUB_SUB_EVENTS.cartUpdate, syncCartCount);
    cartCountSubscribed = true;
  }
  document.addEventListener('cart:updated', syncCartCount);
  document.addEventListener('cart-update', syncCartCount);
  document.addEventListener('DOMContentLoaded', subscribeCartCount, { once:true });
  addEventListener('pageshow', event => { if (event.persisted) syncCartCount(); });
  subscribeCartCount();
  document.addEventListener('visibilitychange',()=>document.querySelectorAll('[data-aw-campaign-video]').forEach(syncVideo));
  reduced.addEventListener('change',()=>{motionOff=reduced.matches;applyMotion();updateScroll();});
  document.addEventListener('shopify:section:load',event=>init(event.target));
  document.addEventListener('shopify:block:select',event=>{const block=event.target.closest?.('[data-aw-editor-block]')||event.target.querySelector?.('[data-aw-editor-block]');if(!block)return;block.scrollIntoView({block:'center',behavior:'smooth'});const details=block.closest('details');if(details)details.open=true;});
  init();
})();
